module.exports = __webpack_public_path__ + "img/galeria-especie-prioritaria-4.13c5be41.jpg";